var lib = {};

export { lib as __exports };
//# sourceMappingURL=index2.js.map
